/**
 * 連続クリック防止
 */
 $(function() {
	// form二度押し防止
	var iClickCount = 0;
	$(document).on('submit','form:not(".available-continuous-click, .form-search")',function(){
		if (iClickCount == 0){
			iClickCount = 1;
		} else {
			alert('ただいま処理中です。OKを押してそのままお待ちください。');
			return false;
		}
	});
});
